
import { defineComponent, onMounted, reactive, ref, watch } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import Widget from "@/components/statsistics/Widget.vue";
import Chart from "@/components/report/Chart.vue";
import List from "@/components/report/List.vue";
import IstatistikService, {
  IIstatistikFilter,
} from "@/services/IstatistikService";
import RestourantService from "@/services/RestourantService";
import moment from "moment";
import { useStore } from "vuex";
import { getFormattedValue, currencyFormat } from "@/core/helpers/momentUtil";
export default defineComponent({
  name: "main-dashboard",
  components: {
    Widget,
    List,
    Chart,
  },
  setup() {
    const store = useStore();
    const currencySymbol = store.getters.currentCountryInfo.currencySymbol;

    const lastUpdateDate = ref<Date | undefined>();
    const monthOrYear = ref(false);
    const modalList = reactive({
      list: [] as any,
    });
    const modalHeader = ref([
      {
        name: "Şirket",
        key: "text",
        sortable: false,
      },
      {
        name: "Değer",
        key: "value",
        sortable: false,
      },
    ]);
    var datas = reactive({
      totalPayment: "0",
      newRestourantCount: "0",
      totalRestourantCount: "0",
      totalOrderCount: "0",
      totalIncome: "0",
      totalIncomePaid: "0",
      totalPaymentList: [] as any,
      notOrderCompany: [] as any,
      companyOrderAvg: [] as any,
      companyPayments: [] as any,
      dailyPayment: {
        categories: [],
        series: [],
      } as any,
    });
    var filters = ref<IIstatistikFilter>({
      startEndDate: [new Date(), new Date()],
      startDate: new Date().toString(),
      endDate: "",
      showAll: false,
      chartDateType: 0,
      companyId: null,
    });

    onMounted(async () => {
      setCurrentPageTitle("Dashboard");
      var updateVal = await RestourantService.getLastOrderUpdateTime();
      lastUpdateDate.value = updateVal.entity;
      await getDatas();
    });
    watch(monthOrYear, async (val) => {
      if (val) {
        await getDatasForYear();
      } else {
        await getDatas();
      }
    });
    async function showAllClick(clickStatus, id) {
      filters.value.showAll = clickStatus;
      if (id == "totalPaymentListId") {
        await totalPaymentList();
      } else if (id == "notOrderCompanyId") {
        await notOrderCompany();
      } else if (id == "companyOrderAvgId") {
        await companyOrderAvg();
      } else if (id == "companyPaymentsId") {
        await companyPayments();
      }
    }
    function chartDateTypeClick(val) {
      filters.value.chartDateType = val;
      dailyPayment();
    }
    async function onChangeDate(val) {
      if (!val) {
        return;
      }
      if (!monthOrYear.value) {
        // ay
        await getDatas();
      } else {
        await getDatasForYear();
      }
    }

    async function getDatasForYear() {
      var allfilters = filters.value;
      allfilters.startDate = moment(allfilters.startEndDate[0])
        .startOf("month")
        .format("MM-DD-YYYY");
      allfilters.endDate = moment(allfilters.startEndDate[1])
        .endOf("month")
        .format("MM-DD-YYYY");

      var totalPayment = await IstatistikService.getTotalPayments(allfilters);
      var newRestourantCount = await IstatistikService.getNewRestourantCount(
        allfilters
      );
      var totalRestourantCount =
        await IstatistikService.getTotalRestourantCount(allfilters);
      var totalOrderCount = await IstatistikService.getTotalOrderCount(
        allfilters
      );
      datas.totalPayment = currencyFormat(totalPayment.entity, true)!;
      datas.newRestourantCount = currencyFormat(newRestourantCount.entity)!;
      datas.totalOrderCount = currencyFormat(totalOrderCount.entity)!;
      datas.totalRestourantCount = currencyFormat(totalRestourantCount.entity)!;

      await totalPaymentList();
      await notOrderCompany();
      await companyOrderAvg();
      await dailyPayment();
    }

    //AYLIK DATALAR START
    async function companyPayments() {
      var companyPayments = await IstatistikService.getListCompanyPayments(
        filters.value
      );
      if (!filters.value.showAll) {
        datas.companyPayments = [];
      } else {
        modalList.list = [];
      }
      companyPayments.list?.forEach((s) => {
        var entity = {
          text: s.companyName,
          value: currencyFormat(s.total, true),
          rawValue: s.total,
        };
        if (!filters.value.showAll) {
          datas.companyPayments.push(entity);
        } else {
          modalList.list.push(entity);
        }
      });
    }

    async function dailyPayment() {
      var dailyPayment = await IstatistikService.getListDailyPayment(
        filters.value
      );

      datas.dailyPayment = [];
      datas.dailyPayment.categories = dailyPayment.list?.map((s) => {
        if (filters.value.chartDateType == 0) {
          //gün
          return moment(s.orderDate, "DD.MM.YYYY HH:mm:ss").format(
            "DD.MM.YYYY"
          );
        } else if (filters.value.chartDateType == 1) {
          //hafta
          return s.orderDate + ". Hafta";
        } else if (filters.value.chartDateType == 2) {
          //saat
          return s.orderDate.padStart(2, "0") + ":00";
        } else if (filters.value.chartDateType == 3) {
          //ay
          return s.orderDate + ". Ay";
        }
      });
      var serieData = dailyPayment.list?.map((s) => s.total);
      datas.dailyPayment.series = [{ name: "Günlük Satış", data: serieData }];
    }
    async function totalPaymentList() {
      var totalPaymentList = await IstatistikService.getListTotalPayments(
        filters.value
      );

      if (!filters.value.showAll) {
        datas.totalPaymentList = [];
      } else {
        modalList.list = [];
      }
      totalPaymentList.list?.forEach((s) => {
        var entity = {
          text: s.companyName,
          value: currencyFormat(s.total, true),
        };
        if (!filters.value.showAll) {
          datas.totalPaymentList.push(entity);
        } else {
          modalList.list.push(entity);
        }
      });
    }

    async function notOrderCompany() {
      var notOrderCompany = await IstatistikService.getListNotOrderCompany(
        filters.value
      );

      if (!filters.value.showAll) {
        datas.notOrderCompany = [];
      } else {
        modalList.list = [];
      }
      notOrderCompany.list?.forEach((s) => {
        var entity = {
          text: s.companyName,
          value: s.total + " Gün",
        };
        if (!filters.value.showAll) {
          datas.notOrderCompany.push(entity);
        } else {
          modalList.list.push(entity);
        }
      });
    }

    async function companyOrderAvg() {
      var companyOrderAvg = await IstatistikService.getListCompanyOrderAvg(
        filters.value
      );

      if (!filters.value.showAll) {
        datas.companyOrderAvg = [];
      } else {
        modalList.list = [];
      }
      companyOrderAvg.list?.forEach((s) => {
        var entity = {
          text: s.companyName,
          value: s.total + " %",
        };
        if (!filters.value.showAll) {
          datas.companyOrderAvg.push(entity);
        } else {
          modalList.list.push(entity);
        }
      });
    }
    async function getDatas() {
      var allfilters = filters.value;
      allfilters.startDate = moment(allfilters.startDate).format("MM-01-YYYY");
      allfilters.endDate = "";

      var totalPayment = await IstatistikService.getTotalPayments(allfilters);

      var newRestourantCount = await IstatistikService.getNewRestourantCount(
        allfilters
      );

      var totalRestourantCount =
        await IstatistikService.getTotalRestourantCount(allfilters);

      var totalOrderCount = await IstatistikService.getTotalOrderCount(
        allfilters
      );

      var totalIncome = await IstatistikService.getTotalIncome(allfilters);

      var totalIncomePaid = await IstatistikService.getTotalIncomePaid(
        allfilters
      );

      datas.totalPayment = currencyFormat(totalPayment.entity, true)!;
      datas.newRestourantCount = currencyFormat(newRestourantCount.entity)!;
      datas.totalOrderCount = currencyFormat(totalOrderCount.entity)!;
      datas.totalRestourantCount = currencyFormat(totalRestourantCount.entity)!;
      datas.totalIncome = currencyFormat(totalIncome.entity)!;
      datas.totalIncomePaid = currencyFormat(totalIncomePaid.entity)!;

      await totalPaymentList();
      await notOrderCompany();
      await companyOrderAvg();
      await companyPayments();
      await dailyPayment();
    }
    //AYLIK DATALAR END

    return {
      monthOrYear,
      lastUpdateDate,
      datas,
      onChangeDate,
      filters,
      showAllClick,
      chartDateTypeClick,
      modalList,
      modalHeader,
      currencySymbol,
      getFormattedValue,
      currencyFormat,
    };
  },
});
